import { registerSW } from 'virtual:pwa-register';

export interface PwaHandlers {
  onNeedRefresh?: () => void;
  onOfflineReady?: () => void;
  onRegistered?: (registration: ServiceWorkerRegistration | undefined) => void;
  onRegisterError?: (error: unknown) => void;
}

export function registerPwa(handlers: PwaHandlers = {}): void {
  if (typeof window === 'undefined') return;
  if (import.meta.env.DEV) return;

  registerSW({
    immediate: true,
    onNeedRefresh() {
      handlers.onNeedRefresh?.();
    },
    onOfflineReady() {
      handlers.onOfflineReady?.();
    },
    onRegistered(registration) {
      handlers.onRegistered?.(registration);
    },
    onRegisterError(error) {
      handlers.onRegisterError?.(error);
    }
  });
}